@for (plan of day.attractions[attractionIndex][planType]; let planIndex = $index; track planIndex) {
<div *ngIf="isShowPlans" class="flex gap-3 justify-around w-full px-8">
  <span class="text-[13px] text-gray-500 translate-y-1.5 font-semibold w-[23%] max-w-[23%] mt-3">{{ plan.time }}
  </span>
  <div class="border-r-2 border-gray-300 border-dashed w-[1px] max-w-[1px]">
    <div class="rounded-full w-6 h-6 flex items-center justify-center -translate-x-[11px] translate-y-3"
      [ngStyle]="{'background-color':getPlanStyle(plan.type).iconColor}">
      <mat-icon class="text-white !w-3.5 !h-3.5 text-[14px] -translate-y-[1px]">
        {{ getPlanStyle(plan.type).icon }}
      </mat-icon>
    </div>
  </div>
  <div class="rounded-2xl ml-5 py-3 px-5 w-[70%] max-w-[70%] mt-3 relative"
    [ngStyle]="{'background-color':getPlanStyle(plan.type).bgColor}">
    <p class="text-sm tracking-normal" [ngStyle]="{'color':getPlanStyle(plan.type).textColor}">{{ plan.title }}</p>
    <p class="text-gray-500 text-xs mt-1 tracking-normal">{{ plan.content }}</p>

    <ng-container *ngIf="isEditMode">
      <div class="absolute top-2 right-9 rounded-full">
        <ig-create-edit-plan [attraction]="day.attractions[attractionIndex]" [plan]="plan"
          (onUpdated)="editPlan(planIndex, $event)">
        </ig-create-edit-plan>
      </div>
      <div class="flex justify-center items-center absolute top-2 right-2 rounded-full w-6 h-6 bg-white cursor-pointer"
        (click)="deletePlan(planIndex)">
        <mat-icon class="!w-4 !h-4 text-[16px] text-red-400">
          delete_forever
        </mat-icon>
      </div>
      <div *ngIf="planIndex < day.attractions[attractionIndex][planType].length - 1"
        class="flex justify-center items-center absolute -bottom-4 right-[46%] z-10 rounded-full w-6 h-6 bg-white cursor-pointer"
        (click)="swapPlan(planIndex)">
        <mat-icon class="!w-4 !h-4 text-[16px] text-blue-900">
          swap_vert
        </mat-icon>
      </div>
    </ng-container>
  </div>
</div>
}
